<template>
	<div class="highlighted-block-card-with-image row p-0 m-0"
		 :style="{
				backgroundColor: data.section_background_color,
			 }"
		 :class="imagePosition"
	>
		<div class="col-12 col-lg-6 p-0">
			<seo-image v-if="data.background" :data="data.background" :class="'highlighted-block-card-with-image-image'" :alt="'Block image'" />
		</div>
		<div class="col-12 col-lg-6 p-5 d-flex flex-column justify-content-between">
			<div class="row">
				<h2
						class="font-weight-bold mb-3"
						:style="{
							color: data.title_color,
						}"
				>
					{{ data.title }}
				</h2>
				<template v-for="item in this.convertedHtmlArray(this.data.lead, this.data.modules.forms, this.data.modules.documents)">
					<template v-if="item.hasOwnProperty('type')">
						<inline-document v-if="item.type === InlineModuleTypeEnum.DOCUMENT" :item="item.items"/>
						<inline-form v-if="item.type === InlineModuleTypeEnum.FORM" :item="item.items"/>
					</template>
					<p v-else v-html="item"></p>
				</template>
			</div>
			<template v-if="this.data?.button?.hasOwnProperty('url') && this.data?.button.url !== null">
				<a v-if="this.data?.button?.url && (this.data?.button?.url?.includes('http') || this.data?.button?.url?.startsWith('#'))" :href="data.button.url" :target="this.data?.button?.url?.startsWith('#') ? '_self' : '_blank'">
					<button-unit
							class="float-end"
							:options="{
								text: data.button.title,
								type: 'button',
								shape: ButtonUnitShape.ROUNDED,
								textColor: data.button.color,
								bgColor: data.button.background,
						}"
					/>
				</a>
				<router-link v-else :to="{path: this.data?.button?.url}">
					<button-unit
							class="float-end"
							:options="{
								text: data.button.title,
								type: 'button',
								shape: ButtonUnitShape.ROUNDED,
								textColor: data.button.color,
								bgColor: data.button.background,
						}"
					/>
				</router-link>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {HighlightedBlockComponentClass, HighlightedBlockComponentInterface} from "../../Views/PageView/Interfaces/Components/HighlightedBlockComponentInterface";
import ButtonUnit from "../Units/ButtonUnit.vue";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";
import {HighlightedBlockComponentTypeEnum} from "../../Views/PageView/Enums/HighlightedBlockComponentTypeEnum";
import {InlineModuleMixin} from "../../Mixins/InlineModuleMixin";
import InlineDocument from "../InlineDocument.vue";
import InlineForm from "../InlineForm.vue";
import {InlineModuleTypeEnum} from "../../Views/PageView/Enums/InlineModuleTypeEnum";
import SeoImage from "../SeoImage.vue";

export default defineComponent({
	name: "HighlightedBlockCardImage",
	components: {SeoImage, InlineDocument, InlineForm, ButtonUnit},
	mixins: [InlineModuleMixin],
	computed: {
		InlineModuleTypeEnum() {
			return InlineModuleTypeEnum
		},
		ButtonUnitShape() {
			return ButtonUnitShape
		},
		imagePosition() {
			// @ts-ignore
			return parseInt(this.data.type) === HighlightedBlockComponentTypeEnum.RIGHT_IMAGE ?
					'flex-row-reverse' :
					'flex-row';
		},
		imageFit() {
			return this.data.imageFit ?? 'cover';
		}
	},
	props: {
		data: {
			type: Object as PropType<HighlightedBlockComponentInterface>,
			default: new HighlightedBlockComponentClass(),
			required: true,
		},
	},
})
</script>

<style scoped>
.highlighted-block-card-with-image-image {
	object-fit: v-bind(imageFit);
}
</style>
